// Cards slider
function cardsInit($) {
  const sliders = $('.cards__slides');

  let initSlider = function (slider) {
    const sliderIndex = slider.data('index');
    const moduleSelector = '.cards--' + sliderIndex;

    const settings = {
      infinite: false,
      arrows: true,
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      lazyLoad: 'anticipated',
      nextArrow: $(moduleSelector).find('.cards__arrows .next-arrow'),
      prevArrow: $(moduleSelector).find('.cards__arrows .prev-arrow'),
      appendDots: $(moduleSelector).find('.cards__arrows .cards__dots-wrapper'),
      variableWidth: true,
      responsive: [
        {
          breakpoint: 860,
          settings: 'unslick'
        },
      ]
    };

    // Initialize/destroy slider depending on screen size
    $(window).on('resize', function () {
      const bIsMobile = typeof isMobile == 'function' && isMobile();
      if (!bIsMobile && !slider.hasClass('slick-initialized')) {
        $(slider).slick(settings);
      } else if (bIsMobile && slider.hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }
    }).trigger('resize');
  };

  for (var i = 0; i < sliders.length; i++) {
    // use setTimeout to initialize each slider in its own JS task to avoid long-running JS tasks
    setTimeout(initSlider, 0, $(sliders[i]));
  }
}


// Set dynamic shadows on mobile cards
function cardsShadow($) {
  const slidesOffsetY = $('.cards__slides')[0].offsetTop;
  const cards = $('.cards__slide');
  cards.each(function(index) {
    const $this = $(this);
    const card = $(this)[0];
    const cardHeight = card.offsetHeight;
    const stickyOffset = 80;
    const cardSpacing = 16;
    const cardOffsetY =  index * (cardHeight + cardSpacing) + slidesOffsetY;
    const fullOpacity = 0.10;
    $(window).on('scroll load', function () {
      if ($(window).width() < 860) {
        const scrollPosY = $(window).scrollTop();
        let opacity = (fullOpacity - (((scrollPosY + stickyOffset) - (cardOffsetY + cardHeight - cardSpacing)) / cardHeight)) * fullOpacity;
        opacity = Math.min(Math.max(opacity, 0), .1);
        $this.css('box-shadow', '0px 0px 20px rgb(51, 51, 51, ' + opacity + ')');
      } else {
        $this.css('box-shadow', '');
      }
    });
  });
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(function($) {
    cardsInit($);
    cardsShadow($);
});
